import { createAction } from '@reduxjs/toolkit';
import { nameSpace } from '../Modules/nameSpace';

const refreshAssetTypeDetails = createAction(
  `${nameSpace}/refreshAssetTypeDetails`,
);

export { refreshAssetTypeDetails };
